import { render, screen } from '@testing-library/react'
import EducationPage from './EducationPage'

describe('EducationPage', () => {
  test('renders the education content as a standalone page', () => {
    render(<EducationPage />)

    expect(screen.getByRole('heading', { name: /educación menstrual/i })).toBeTruthy()
    expect(screen.getByRole('link', { name: /volver/i }).getAttribute('href')).toBe('/asociacion')
    expect(screen.getByText(/procesos formativos y sensibilización/i)).toBeTruthy()
    expect(screen.getByRole('link', { name: /cast/i }).getAttribute('href')).toBe('/pdfs/propuesta_cast.pdf')
    expect(screen.getByRole('link', { name: /cat/i }).getAttribute('href')).toBe('/pdfs/propuesta_cat.pdf')
  })
})
